import {
  CategoriesResponse,
  CountriesResponse,
  LanguageResponse,
  SubcategoriesResponse,
} from "../types/types";
import { callApi } from "./api.service";

// Fetch countries API
export const FetchCountrieslookup = async () => {
  return await callApi<CountriesResponse>(
    "/api/lookup/countries",
    "GET",
    false // No authentication required for this call
  );
};

// Fetch Category API
export const FetchCategorieslookup = async () => {
  return await callApi<CategoriesResponse>(
    "/api/lookup/categories",
    "GET",
    false // No authentication required for this call
  );
};

// Fetch Subcategory API
export const FetchSubcategorieslookup = async (data?:any) => {
  return await callApi<SubcategoriesResponse>(
    `/api/lookup/subcategories?category_id=${data}`,
    "GET",
    false // No authentication required for this call
  );
};

// Fetch languages API
export const FetchLanguageslookup = async () => {
  return await callApi<LanguageResponse>(
    "/api/lookup/languages",
    "GET",
    false // No authentication required for this call
  );
};